import type { Tripulante } from "../types/tripulante";
import axios from "axios";
import type { Ref } from "vue";
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";

export default function useTripulantes() {
  const store = useStore(key);
  let lstTripulantes: Ref<Tripulante[]> = ref([]);

  async function getTripulantes(empresa: string) {
    try {
      await axios
        .get(
          store.state.url + "api/Tripulante/GetTripulantes?company=" + empresa,
          {
            headers: {},
          }
        )
        .then((response) => {
          if (response.status == 200) {
            lstTripulantes.value = response.data as Tripulante[];
            // console.log(lstTripulantes.value);
          } else {
            console.log(response.statusText);
          }
        })
        .catch(function (error) {
          console.log(error.message);
        });
    } catch (error) {
      console.log(error);
    }
  }

  return { getTripulantes, lstTripulantes };
}
